import React from "react";
import styles from "./CaseStudyStats.module.scss";

/**
 * Stats row for the case study banner (e.g. "−38% / Landed Lead Time"), fed by
 * `cpd_case_study.metrics`. Renders nothing without stats.
 *
 * @param {{ value: string, label: string }[] | null} stats
 */
const CaseStudyStats = ({ stats }) => {
  // 0 / "0" are valid values (e.g. "0 assay rejections").
  const items = Array.isArray(stats) ? stats.filter((s) => s?.label && s.value != null && s.value !== "") : [];
  if (items.length === 0) return null;

  return (
    <dl className={styles.stats}>
      {items.map((stat) => (
        <div key={stat.label} className={styles.stat}>
          <dt className={styles.label}>{stat.label}</dt>
          <dd className={styles.value}>{stat.value}</dd>
        </div>
      ))}
    </dl>
  );
};

export default CaseStudyStats;
